export const grey = {
    100: '#5a6675',
    200: '#8fa0b3',
    300: '#d2d9e0',
    400: '#f4f5f7',
    500: 'rgba(250,250,250,1)',
    660: '#B1B1B1',
};

export const orange = {
    100: 'rgba(255, 146, 61,1)',
    200: 'rgba(255, 200, 158,1)',
    300: '#FDF2D5',
};

export const green = {
    100: 'rgba(222,246,204,1)',
};

export const blue = {
    100: 'rgba(0,86,173,1)',
    200: 'rgba(131,164,223,1)',
    300: 'rgba(200,219,255,1)',
    400: 'rgba(242,247,255,1)',
};

export const red = {
    100: 'rgba(255, 85, 80,1)',
    200: 'rgba(255,155,135,1)',
    300: 'rgba(255,155,135,1)',
    400: 'rgba(255,235,230,1)',
};

export const yellow = {
    100: 'rgba(255, 251, 0, 1)',
    200: 'rgba(255, 253, 143, 1)',
    300: 'rgba(252, 238, 199, 0.75)',
};

export const common = {
    white: '#fff',
    black: '#000',
    dark: '#222222',
};
